<template>
  <ul class="table__row">
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">{{ dataUser.id }}</p>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text pointer" @click="openAside">
        {{ dataUser.name }} {{ dataUser.patronymic }} {{ dataUser.lastname }}
      </p>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">{{ dataUser.city }}</p>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">{{ dataUser.email }}</p>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">
        <Phone :value="dataUser.phone"></Phone>
      </p>
    </li>
    <li class="table__col">
      <template v-if="groupsArray && groupsArray.length > 0">
        <p
          v-if="groupsArray.length === 1"
          class="table__text -overflow- -users-table-text pointer"
          @click="openGroup(groupsArray[0].id)"
        >
          {{ groupsArray[0].name }}
        </p>
        <Button
          v-else
          ref="tablerow"
          class="button button-action -users-table-__button -users-table-text pointer"
          @click="openGroupsList"
          >{{ groupCounter(groupsArray.length) }}</Button
        >
        <Popup
          v-if="isOpen"
          v-model="isOpen"
          class="users-groups-popup"
          :parent="$refs.tablerow.$el"
          :scroll-trigger="scrollTrigger"
        >
          <template v-for="(group, idx) in groupsArray">
            <p
              :key="'popup' + idx + '_' + dataUser.id"
              class="table__text -users-table-text pop__up-row -overflow-"
            >
              <span @click="openGroup(group.id)">{{ group.name }}</span>
              <Icon
                v-if="$permissionsDelete"
                class="width-10px"
                icon="delete"
                @click="selectedGroup(group.id)"
              ></Icon>
            </p>
            <transition v-if="confirm === group.id" :key="idx" name="fadePreloader">
              <Confirm
                v-model="selected"
                class="table__confirm-action"
                :parent="$refs.tablerow.$el"
                :is-open.sync="confirm"
                :selected-field="selectedField"
                :scroll-trigger="scrollTrigger"
              ></Confirm>
            </transition>
          </template>
        </Popup>
      </template>
      <p v-else class="table__text"></p>
    </li>
    <li class="table__col">
      <InlineSocials
        :vk="dataUser.vkLink"
        :fb="dataUser.fbLink"
        :insta="dataUser.instaLink"
      ></InlineSocials>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">{{ dataUser.niche }}</p>
    </li>
    <li class="table__col">
      <p class="table__text -overflow- -users-table-text">{{ dataUser.profitPerWeek }}</p>
    </li>
    <li v-if="$permissionsUpdate" class="table__col">
      <p class="table__text -users-table-text">
        <span>
          <div
            v-tiny-text-tooltip="{ text: 'Получить ссылку сброса пароля' }"
            class="width-15px position-relative"
          >
            <Icon class="pointer" icon="reset-password" @click="resetPassword"></Icon>
          </div>
        </span>
      </p>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash';
import vClickOutside from 'v-click-outside';
import InlineSocials from '@/components/InlineSocials';
import counterNameFilter from '@/filters/counterName.filter';

import { mapState, mapActions } from 'vuex';

export default {
  components: { InlineSocials },
  directives: { clickOutside: vClickOutside.directive },
  props: ['user', 'groups', 'deleteFunc'],
  data() {
    return {
      dataUser: '',
      selected: '',
      confirm: false,
      isOpen: false,
      promiseInterval: '',
      selectedField: {
        text: 'Удалить',
        func: this.deleteUser,
        icon: 'delete',
        iconWidth: '10px',
        confirm: true,
        confirmTitle: 'Вы уверены, что хотите удалить пользователя из группы?',
        confirmApplyText: 'Удалить',
        confirmCancelText: 'Отменить',
        red: true
      }
    };
  },
  computed: {
    ...mapState('auth', {
      link: s => s.data.resetPasswordLink,
      $permissions: s => s.data.user.permissions.userModuleAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    groupsArray() {
      const arr = [];
      if (this.dataUser.groupIds && this.dataUser.groupIds.length && this.groups.length) {
        this.dataUser.groupIds.forEach(el => {
          const group = this.groups.find(elem => elem.id === el);
          if (group) {
            arr.push(group);
          }
        });
      }

      return arr;
    },
    scrollTrigger() {
      return document.querySelector('.-users-table- .table__body');
    }
  },
  watch: {
    link(val) {
      navigator.clipboard.writeText(val);
    }
  },
  mounted() {
    this.dataUser = _.cloneDeep(this.user);
  },
  methods: {
    ...mapActions('auth', ['getResetPasswordLink']),
    ...mapActions('users', ['setAsideMeta', 'setAsideData']),
    openUser() {
      this.$store.dispatch('users/setAsideData', {
        path: 'user',
        value: this.user
      });
      this.$store.dispatch('users/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    openGroup(groupId) {
      this.$router.push({ path: `/users/group/${groupId}/users` });
    },
    openAside() {
      this.setAsideData({ path: 'user', value: this.dataUser });
      this.setAsideMeta({ path: 'isOpen', value: true });
    },
    openGroupsList() {
      this.isOpen = true;
    },
    async selectedGroup(id) {
      let result;

      this.confirm = id;
      result = await new Promise((res, rej) => {
        this.promiseInterval = setInterval(() => {
          if (this.selected === 'success') {
            res('next');
          } else if (this.selected === 'cancel') {
            res('cancel');
          }
        }, 50);
      });

      this.clearConfirmData();

      if (result === 'cancel') {
        return;
      }

      if (result === 'next') {
        setTimeout(() => {
          this.dataUser.groupIds = [...this.dataUser.groupIds.filter(el => el != id)];
          this.$emit('click', { groupId: id, user: this.user });
        }, 0);
      }
    },
    clearConfirmData() {
      this.confirm = false;
      this.selected = '';
      if (this.promiseInterval) {
        clearInterval(this.promiseInterval);
      }
    },
    resetPassword() {
      this.getResetPasswordLink(this.dataUser.authUserId);
    },
    groupCounter(counter) {
      const names = ['группа', 'группы', 'групп'];
      return counterNameFilter(+counter, names);
    }
  }
};
</script>
